module.exports = __webpack_public_path__ + "static/media/geom.cbbe8178.png";